import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  linkedSignal,
  output,
} from '@angular/core';
import {
  ButtonComponent,
  IconComponent,
  ItemComponent,
  ItemDescriptionComponent,
  ItemGroupComponent,
  ItemLeadingComponent,
  ItemTitleComponent,
  ItemTrailingComponent,
  SoftSlotDirective,
  ToolTipDirective,
  TranslatePipe,
} from '@softline/ui-core';
import { WorkflowParticipant, WorkflowRole } from '../../types/workflow';

@Component({
  selector: 'soft-workflow-participants',
  imports: [
    ButtonComponent,
    IconComponent,
    ItemComponent,
    ItemDescriptionComponent,
    ItemGroupComponent,
    ItemLeadingComponent,
    ItemTitleComponent,
    ItemTrailingComponent,
    SoftSlotDirective,
    ToolTipDirective,
    TranslatePipe,
  ],
  templateUrl: './workflow-participants.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowParticipants {
  readonly roles = input<WorkflowRole[]>([]);

  readonly addParticipant = output<{ role: WorkflowRole; isGroup: boolean }>();
  readonly deleteParticipant = output<WorkflowParticipant & { role: string }>();

  private readonly selectedRole = linkedSignal<WorkflowRole | null>(
    () => this.roles()[0] ?? null
  );

  protected selectRole(role: WorkflowRole): void {
    this.selectedRole.set(role);
  }

  protected isSelected(role: WorkflowRole): boolean {
    return this.selectedRole()?.role === role.role;
  }

  readonly filteredParticipants = computed(() => this.selectedRole()?.participants ?? []);

  protected onAddClick(isGroup: boolean): void {
    const role = this.selectedRole();
    if (role) this.addParticipant.emit({ role: role, isGroup });
  }

  protected onDeleteClick(participant: WorkflowParticipant): void {
    const role = this.selectedRole();
    if (role) this.deleteParticipant.emit({ ...participant, role: role.role });
  }
}
